<template>
<div class="chapter">
<div class="inner_page">
<h2 class="center" id="start"><b class="sans_bold">WATCHERS</b></h2>
<p class="center"><span><b class="sans_normal">Case File: 7222</b></span></p>
<p class="noind" style="margin-top:20px;"><b class="sans_normal">Name: Samuel Hughes</b></p>
<p class="noind" style="margin-top:20px;"><b class="sans_normal">Age: 13</b></p>
<p class="noind" style="margin-top:20px;"><b class="sans_normal">First Contact: 41.33.02</b></p>
<p class="noind" style="margin-top:20px;"><b class="sans_normal">Acceptance: Yes</b></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 4start.vue?38755efc